<template>
  <div>
    <ApprovalDocument
      :board="board"
      :value="form.body"

      @close="onClickClose"
      @delete="onClickDelete"
      @recall="onClickRecall"
      @print="onClickPrint"
      @tempsave="onClickTempsave"
      @retempsave="onClickReTempsave"
      @upload="onClickUpload"
      @ok="onClickOk"
      @no="onClickNo"
    >
      <template #header="props">
        <p class="h4 flex" style="align-items: center">
          승강기 자체점검
          <vs-input class="ml-8 mr-2" style="width:100px;" v-model="form.header.year" :readonly="true"/>년
          <vs-input class="ml-8 mr-2" style="width:100px;" v-model="form.header.month" :readonly="board.readonly"/>월
        </p>
      </template>

      <template #body="props">
        <div id="print">

          <!-- 기본정보 -->
          <m-group label="기본정보" :division="3">
            <m-form label="사업장명" :value="form.body.baseInfo.project_name" >
              <vs-input class="w-full" v-model="form.body.baseInfo.project_name" :readonly="true"/>
            </m-form>
            <m-form label="소속" :value="form.body.baseInfo.com_name" >
              <vs-input class="w-full" v-model="form.body.baseInfo.com_name" :readonly="true"/>
            </m-form>
            <m-form label="점검담당자" :value="form.body.baseInfo.manager" >
              <vs-input class="w-full" v-model="form.body.baseInfo.manager"/>
            </m-form>
            <m-form label="점검일자" :value="form.body.baseInfo.check_date" >
              <date-selector class="w-full" v-model="form.body.baseInfo.check_date" />
            </m-form>
            <m-form label="점검시간" :value="`${form.body.baseInfo.check_stime} ~ ${form.body.baseInfo.check_etime}`" >
              <div class="grid" style="grid-template-columns: 1fr 40px 1fr;">
                <time-selector class="w-full" v-model="form.body.baseInfo.check_stime" />
                <span class="w-full flex" style="justify-content: center; align-items: center;">~</span>
                <time-selector class="w-full" v-model="form.body.baseInfo.check_etime" />
              </div>
            </m-form>
            <m-form label="관리주체" :value="form.body.baseInfo.관리주체" >
              <vs-input class="w-full" v-model="form.body.baseInfo.관리주체"/>
            </m-form>
            <m-form label="관리주체 확인실시" :value="form.body.baseInfo.관리주체확인실시" >
              <vs-input class="w-full" v-model="form.body.baseInfo.관리주체확인실시"/>
            </m-form>
          </m-group>

          <!-- 승강기정보 -->
          <m-group style="margin-top: 2rem;" label="승강기정보" :division="3">
            <m-form label="승강기고유번호" :value="form.body.elevatorInfo.승강기고유번호" >
              <vs-input class="w-full" v-model="form.body.elevatorInfo.승강기고유번호"/>
            </m-form>
            <m-form label="호기(설치장소)" :value="form.body.elevatorInfo.호기설치장소" >
              <vs-input class="w-full" v-model="form.body.elevatorInfo.호기설치장소"/>
            </m-form>
            <m-form label="승강기종류" :value="form.body.elevatorInfo.승강기종류" >
              <vs-input class="w-full" v-model="form.body.elevatorInfo.승강기종류"/>
            </m-form>
            <m-form label="승강기모델" :value="form.body.elevatorInfo.승강기모델" >
              <vs-input class="w-full" v-model="form.body.elevatorInfo.승강기모델"/>
            </m-form>
          </m-group>
          <m-form class="mb-4" label="점검대상" :value="selectedWorkTypeList">
            <div class="w-full flex flex-wrap" >
                <span
                  v-for="(workType, index) in form.body.elevatorInfo.workTypeTitleList"
                  :key="`work_type_list_${index}`">
                  <vs-checkbox v-model="form.body.elevatorInfo.workType[index]"
                               class="mr-4"
                  >{{ workType }}</vs-checkbox>
                </span>
            </div>
          </m-form>

          <!-- 점검항목 및 점검결과 -->
          <m-title style="margin-top: 2rem;" label="점검항목 및 점검결과" />
          <m-check-table
            title="구분"
            menu-width="365px"
            :menus="menuA"
            :isHideGroup="isPrint"
          >
            <template v-slot:header>
              <check-table-header :division="1" title="점검내용"/>
            </template>
            <template v-slot:default="{ menu }">
              <div style="display: grid; grid-template-columns: repeat(1, 1fr)">
                <check-table-body-item
                  v-for="(work, index) in form.body.check.checkListA[menu]"
                  :key="`form.body.check.checkListA_${work.text}_${index}`"
                  :dataTypes="menuResults"
                  :value="work"
                  :is-print="isPrint"
                />
              </div>
            </template>
          </m-check-table>

          <!-- 특이사항 -->
          <m-title style="margin-top: 2rem;" label="특이사항" />
          <span v-if="isPrint">{{ form.body.etc }}</span>
          <vs-textarea v-else v-model="form.body.etc" :rows="5"/>

          <!-- 첨부파일 -->
          <file-upload-module class="w-full" style="margin-top: 2rem;" v-model="fileList"></file-upload-module>
        </div>
      </template>

    </ApprovalDocument>
  </div>
</template>

<script>
import ApprovalDocument from '@/views/write/document/ApprovalDocument'
import Template from '@/views/admin/approval/Template'
import SafetyAccidentBasicData from '@/views/content/safety/SafetyAccidentBasicData'
import SafetyCheckBasicInfo from '@/views/write/safetycheck/components/SafetyCheckBasicInfo'
import MGroup from '@/components/base-ui/MGroup'
import MForm from '@/components/base-ui/MForm'
import MTitle from '@/components/base-ui/MTitle'
import MCheckTable from '@/components/base-ui/MCheckTable'
import CheckTableHeader from '@/views/write/safetycheck/elevator_safety_check/component/CheckTableHeader'
import CheckTableBodyItem from '@/views/write/safetycheck/elevator_safety_check/component/CheckTableBodyItem'
import FileUploadModule from '@/views/modules/FileUploadModule'
import DateSelector from '@/views/components/DateSelector'
import TimeSelector from '@/views/components/TimeSelector'

export default {
  name: 'ElevatorSafetyCheck',
  components: {
    TimeSelector,
    DateSelector,
    FileUploadModule,
    CheckTableBodyItem,
    CheckTableHeader,
    MCheckTable,
    MTitle,
    MForm,
    MGroup,
    SafetyCheckBasicInfo,
    SafetyAccidentBasicData,
    Template,
    ApprovalDocument},
  data () {
    return {
      isPrint: false,

      // TODO : 글쓰기 정보 및 권한
      board: {
        slug: this.boardSlug,
        statusCode: '', // 문서 상태코드
        writer: {}, //작성자 정보
        turnApprovalId: 0, // 결재자 ID
        readonly: false, // 읽기전용인가
        isWriter: true, // 작성자인가
        savable: true, // 임시저장이 가능하나
        isCompleteApproval: false, // 결재완료된 문서인가
        isTurnApproval: false, // 결재할 차례인가
        approvalLine: [], // 결재라인
        commentList: [] // 댓글리스트
      },

      form: {
        header: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1
        },
        body: {
          baseInfo: {
            project_name: '',
            com_name: '',
            manager: '',
            check_stime: '',
            check_etime: '',
            관리주체: '',
            관리주체확인실시: ''
          },
          elevatorInfo: {
            승강기고유번호: '',
            호기설치장소: '',
            승강기종류: '',
            승강기모델: '',
            workTypeTitleList: [
              '기계류 공간', '승강로', '카, 점검운전 및 접근허용', '매다는 장치, 보상수단, 제동 및 권상', '안전회로',
              '카 및 균형추의추락방지안전장치와과속에 대한 보호', '주행성능 측정', '보호장치', '전기적 보호', '장애인용 엘리베이터 추가요건',
              '소방구조용 엘리베이터 추가요건', '피난용 엘리베이터 추가요건'
            ],
            workType: [false, false]
          },
          check: {
            checkListA: {
              '기계류 공간' : [
                // 일반사항
                { text: '설치 및 작동 상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피트 및 기계류 공간 등의 접근', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '기계류 공간 등의 안전표시', cycle:'6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '오일쿨러 설치 및 작동 상태', cycle:'6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '조명의 점등 상태 및 조도', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '기능 및 작동 상태', cycle:'1',  isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '수동 비상운전수단의 설치 및 작동상태', cycle:'1',  isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '자동구출 운전의 설치 및 작동상태', cycle:'1',  isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '승강로(피트) 비상통화장치의 설치 및 작동 상태', cycle:'1',  isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '누수 및 청결상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '윤활유의 유량 및 노후상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '감속기 및 관련부품의 노후 및 작동 상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '이상 소음 및 진동 발생 상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '도르래 및 관련 부품의 마모 및 노후 상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '도르래 홈의 마모 상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '베어링 및 관련 부품의 노후.작동 상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '이상 소음 및 진동 발생 상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '전동기 및 관련 부품의 노후.작동 상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '이상 소음 및 진동 발생 상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 기계실 내의 기계류
                { text: '용도 이외의 설비 비치 여부', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '출입문의 설치 및 잠금 상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '바닥 개구부 낙하방지수단의 설치 상태', cycle:'6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '환기 상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '조명 점등 상태 및 조도', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '콘센트의 설치상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '양중용 지지대 및 고리에 허용하중 표시 상태', cycle:'6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 승강로 내의 기계류
                { text: '작업공간 확보 상태', cycle:'6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '기계적인 장치의 설치 및 작동 상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '점검문의 설치 및 작동 상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '기계적인 장치의 설치 및 작동 상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피트 출입문의 경우 전기안전장치 작동상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피트 탈출 수직틈새의 확보상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '플랫폼 전기안전장치의 설치 및 작동상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '플랫폼 접근 점검문의 설치 및 작동 상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '점검운전 조작반의 설치 및 작동 상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '플랫폼에 최대 허용하중 표시 상태', cycle:'6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '점검문의 설치 및 작동 상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '조명의 점등 상태 및 조도', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '양중용 지지대 및 고리에 허용하중 표시 상태', cycle:'6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 승강로 외부의 기계류
                { text: '엘리베이터와 관계없는 타 설비의 비치여부', cycle:'6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '출입문의 잠금 및 설치상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '환기 상태', cycle:'6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '조명의 점등상태 및 조도', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '콘센트의 설치상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 풀리 공간간
                { text: '엘리베이터와 관계없는 타 설비의 비치여부', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '출입문의 잠금 및 설치상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '환기 상태', cycle:'1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '조명의 점등상태 및 조도', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '콘센트의 설치상태', cycle:'3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
              ],
              '승강로' : [
                // 1. 피트 내 설비
                { text: '점검운전 조작반의 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피트 내 정지장치의 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피트 점검운전스위치 작동 후 복귀상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '튀어오름 방지장치의 설치 및 작동상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피트 내 누수 및 청결상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 2. 틈새 및 여유거리
                { text: '상부공간, 피난공간 확보상태', cycle: '6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '하부공간, 피난공간 확보상태', cycle: '6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피난공간 자세유형 표지 부착상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 3. 완충기
                { text: '고정 및 설치상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '전기안전장치 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '고정 및 설치상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '전기안전장치 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 4. 완충기 받침대
                { text: '완충기 받침대 고정 및 설치상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 5. 승강로 내의 보호
                { text: '밀폐식 승강로 개구부등 손상여부 확인', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '균형추(평형추) 칸막이 설치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피트 내 카간 칸막이 설치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '반-밀폐식 승강로 접근방지 및 보호수단', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '승강로 환기 상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '폴리의 로프 고정장치 설치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '도르래, 폴리 스프로킷의 보호 조치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '균형추(평형추) 추락방지안전장치 작동 상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '타 설비 비치여부', cycle: '6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '출입문, 비상문 및 점검문의 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '편향 도르래 등의 추락방지안전장치 설치상태', cycle: '6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 6. 승강장문
                { text: '문짝과 문짝, 문틀 또는, 문턱 사이의 틈새', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '승강장문 유리 사용 시 손상상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '어린이 손끼임방지수단 설치상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '승강장문 및 관련 부품의 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 7. 조명 및 콘센트
                { text: '승강로 내 조명의 점등상태 및 조도', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피트 콘센트 설치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 8. 주행안내 레일
                { text: '주행안내 레일 고정 및 설치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 9. 균형추
                { text: '균형추의 고정 및 설치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
              ],
              '카, 점검운전 및 접근허용' : [
                // 1. 카
                { text: '유리가 사용된 카벽의 손잡이 고정 설치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '카 내부 표기상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '비상통화장치 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '조명의 점등상태 및 조도', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '비상등 조도 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '과부하감지장치 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '에이프런 고정 및 설치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '카 내 버튼의 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '카 내 층 표시장치 등 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 2. 카 상부
                { text: '점검운전 조작반 정지장치 및 콘센트의 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '점검운전 제어시스템 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '비상등의 조도 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '보호난간의 고정상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '청결상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 3. 카문
                { text: '문짝과 문짝, 문틀, 문턱 사이의 틈새', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '어린이 손끼임방지 수단 및 설치', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '카 문턱과 승강장 문턱사이의 거리', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '문의 개폐방식이 조합된 경우 문간 틈새', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '카문 및 관련 부품의 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 4. 승강장문 및 카문의 시험
                { text: '문닫힘안전장치의 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '문 열림버튼의 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '문 벌어짐 틈새의 설치상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '승강장 점등상태 및 조도', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '승강장문 비상해제장치 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '승강장문 닫힘 확인장치 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '승강장문 잠금장치 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '카문 잠금장치 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '카문 닫힘 확인장치 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '수동개폐식 문의 “카 있음” 표시', cycle: '6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 5. 승강장
                { text: '승강장의 층 표시상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '승강장 호출버튼의 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
              ],
              '매다는 장치, 보상수단, 제동 및 권상' : [
                // 1. 매다는 장치
                { text: '로프(벨트)의 마모 및 파단상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '로프(벨트) 단말부의 고정 및 설치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '로프(벨트)간 장력 균등상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '체인의 결합상태(핀, 링크 등)', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '체인끝 부분의 지지대 고정상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '체인간 장력 균등 상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 2. 이완장치
                { text: '매다는 장치의 이완감지 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 3. 보상수단
                { text: '보상수단의 고정 및 설치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '인장 또는 튀어오름 방지장치의 설치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 4. 권상/제동
                { text: '권상 도르레의 마모상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '브레이크의 권상/제동 상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '브레이크 및 관련 부품의 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

              ],
              '안전회로' : [
                // 1. 안전접점 및 회로
                { text: '파이널 리미트 스위치의 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '정지장치의 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '강제감속장치의 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '전기안전장치 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
              ],
              '카 및 균형추의추락방지안전장치와과속에 대한 보호' : [
                // 1. 카 추락방지 안전장치
                { text: '추락방지안전장치의 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '추락방지안전장치 작동 시 카의 수평도', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '전기안전장치 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 2. 카 측 과속조절기
                { text: '과속조절기 전기안전장치 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '인장폴리 설치상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '로프 마모 및 파단상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 3. 균형추(평형추) 추락방지 안전장치
                { text: '균형추(평형추) 추락방지안전장치 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 4. 균형추/평형추 과속조절기
                { text: '과속조절기 전기안전장치 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '인장폴리 설치상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '로프 마모 및 파단상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 5. 멈춤 쇠 장치
                { text: '멈춤 쇠 장치 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '멈춤 쇠 장치와 각 층의 지지대 설치상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 6. 전기적크리핑 방지시스템
                { text: '전기적 크리핑 방지시스템의 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 7. 카의상승과속방지장치
                { text: '상승과속방지장치 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '상승과속방지장치 전기안전장치 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 8. 카의상승과속방지장치
                { text: '개문출발방지장치 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '개문출발방지장치 전기안전장치 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
              ],
              '주행성능 측정' : [
                // 1. 일반적인 주행시험
                { text: '카의 주행 속도', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '승강장에 정지 시 착상정확도', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },

                // 2. 유압시스템의 점검검
                { text: '유압시스템 관련 밸브 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '로프, 체인이완감지장치 설치 및 작동 상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '유압유의 온도감지장치 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '유압탱크 설치상태 및 유량 상태', cycle: '6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '배관, 밸브 등의 이음/고정 및 부식/누유상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '수동펌프 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '소화설비 비치 및 표기상태', cycle: '6', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '잭 및 관련 부품의 설치 및 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
              ],
              '보호장치' : [
                { text: '전동기 과열보호장치 작동상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '전동기 구동시간 제한장치 작동상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '조명 및 콘센트의 과전류 보호상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
              ],
              '전기적 보호' : [
                { text: '전동기 및 조명의 절연저항', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '전기배선(이동케이블 등) 설치 및 손상상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '모든 접지선의 연결 상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '카문 및 승강장문의 바이패스 기능', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
              ],
              '장애인용 엘리베이터 추가요건' : [
                { text: '승강장 문턱과 카 문턱 사이의 거리', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '호출버튼, 조작반, 통화장치 등의 작동상태', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '조작반, 통화장치 등에 점자표시 여부', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                // 3. 기타설비
                { text: '손잡이, 거울 등의 설치상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '신호장치, 표시장치 등의 작동상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '문열림 대기시간', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '카내 및 승강장의 조명 점등상태 및 조도', cycle: '1', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
              ],
              '소방구조용 엘리베이터 추가요건' : [
                { text: '모든 출입구마다 정지되는지 여부', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피트 침수 방지수단 설치 및 작동상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '카 외부 구출수단', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '자체 구출수단', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '소방운전 스위치의 설치 및 작동상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '소방운전 작동시 안전장치 작동상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '1단계, 2단계 소방운전 시 작동상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '소방통화시스템의 작동상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
              ],
              '피난용 엘리베이터 추가요건' : [
                { text: '피난용 엘리베이터 추가요건', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피트 침수 방지수단 설치 및 작동상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '카 외부 구출수단', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '자체 구출수단', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피난운전 스위치의 설치 및 작동상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피난운전 스위치 작동 시 엘리베이터 관련 설비의 작동상태', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
                { text: '피난통화시스템 작동상태 적합성', cycle: '3', isAction: false, data: [false, false, false, false, false, false, false, false, false, false] },
              ],
            },
            now: '',
            next: ''
          },
          etc: '',

        }
      },

      fileList: [],
      test: 'test'
    }
  },
  computed:{
    selectedWorkTypeList () {
      let selected = ''
      let count = 0
      for (let i = 0; i < this.form.body.elevatorInfo.workTypeTitleList.length; i++) {
        if (this.form.body.elevatorInfo.workType[i]) {
          if (count > 0) {
            selected += ', '
          }
          selected += this.form.body.elevatorInfo.workTypeTitleList[i]
          count++
        }
      }
      return selected
    },
    점검종별List () {
      return [
        {text:'월', value:'월'},
        {text:'분', value:'분'},
        {text:'반', value:'반'},
        {text:'년', value:'년'}
      ]
    },
    isUpdateMode () {
      return this.$route.params.postId
    },
    boardSlug () {
      return this.$route.params.boardSlug
    },
    projectId () {
      return parseInt(this.$route.params.proj_id)
    },
    menuA () {
      const menus = []
      const list = []
      list.push({
        name: '기계류 공간',
        child: [
          {
            name: '1. 일반사항',
            child: [
              { name: '(1) 주개폐기' },
              { name: '(2) 접근' },
              { name: '(3) 안전표시' },
              { name: '(4) 오일쿨러' },
              { name: '(5) 비상운전 및 작동시험을 위한 장치', child: ['', '', '', ''] },
              { name: '(6) 통신' },
              { name: '(7) 환경' },
              { name: '(8) 감속기', child: ['', '', ''] },
              { name: '(9) 도르래', child: ['', ''] },
              { name: '(10) 베어링', child: ['', ''] },
              { name: '(11) 전동기', child: ['', ''] }
            ]
          },
          {
            name: '2. 기계실 내의 기계류',
            child: [{ name: '(1) 기계실 내의 기계류', child: ['', '', '', '', '', '', ''] }]
          },
          {
            name: '3. 승강로 내의 기계류',
            child: [
              { name: '(1) 승강로 내 작업공간' },
              { name: '(2) 카내 또는 카 상부 작업공간', child: ['', ''] },
              { name: '(3) 피트 내 작업공간', child: ['', '', ''] },
              { name: '(4) 플랫폼위의 작업공간', child: ['', '', '', ''] },
              { name: '(5) 승강로외부 작업공간', child: ['', '', ''] }
            ]
          },
          {
            name: '4. 승강로 외부의 기계류',
            child: [{ name: '-', child: ['', '', '', '', ''] }]
          },
          {
            name: '5. 풀리 공간',
            child: [{ name: '(1) 풀리실', child: ['', '', '', '', ''] }]
          }
        ]
      })
      list.push({
        name: '승강로',
        child: [
          {
            name: '1. 피트 내 설비',
            child: [{ name : '-', child: ['', '', '', '', '']}]
          },
          {
            name: '2. 틈새 및 여유거리',
            child: [{ name : '-', child: ['', '', '']}]
          },
          {
            name: '3. 완충기',
            child: [
              { name : '(1) 카측 완충기', child: ['', '']},
              { name : '(2) 균형추측 완충기', child: ['', '']}
            ]
          },
          {
            name: '4. 완충기 받침대',
            child: [{ name : '-'}]
          },
          {
            name: '5. 승강로 내의 보호',
            child: [{ name : '-', child: ['', '', '', '', '', '', '', '', '', '', '']}]
          },
          {
            name: '6. 승강장문',
            child: [{ name : '-', child: ['', '', '', '']}]
          },
          {
            name: '7. 조명 및 콘센트',
            child: [{ name : '-', child: ['', '']}]
          },
          {
            name: '8. 주행안내 레일',
            child: [{ name : '-'}]
          },
          {
            name: '9. 균형추',
            child: [{ name : '-'}]
          }
        ]
      })
      list.push({
        name: '카, 점검운전 및 접근허용',
        child: [
          {
            name: '1. 카',
            child: [{ name : '-', child: ['', '', '', '', '', '', '', '', '']}]
          },
          {
            name: '2. 카 상부',
            child: [{ name : '-', child: ['', '', '', '', '']}]
          },
          {
            name: '3. 카문',
            child: [{ name : '-', child: ['', '', '', '', '']}]
          },
          {
            name: '4. 승강장문 및 카문의 시험',
            child: [{ name : '-', child: ['', '', '', '', '', '', '', '', '', '']}]
          },
          {
            name: '5. 승강장',
            child: [{ name : '-', child: ['', '']}]
          }
        ]
      })
      list.push({
        name: '매다는 장치, 보상수단, 제동 및 권상',
        child: [
          {
            name: '1. 매다는 장치',
            child: [
              { name: '로프(벨트)', child: ['', '', '']},
              { name: '체인', child: ['', '', '']},
            ]
          },
          {
            name: '2. 이완장치',
            child: [{ name: '-'}]
          },
          {
            name: '3. 보상수단',
            child: [{ name: '-', child: ['', '']}]
          },
          {
            name: '4. 권상/제동',
            child: [{ name: '-', child: ['', '', '']}]
          }
        ]
      })
      list.push({
        name: '안전회로',
        child: [
          {
            name: '1. 안전접점 및 회로',
            child: [{ name: '-', child: ['', '', '', '']}]
          }
        ]
      })
      list.push({
        name: '카 및 균형추의추락방지안전장치와과속에 대한 보호',
        child: [
          {
            name: '1. 카 추락방지 안전장치',
            child: [{ name: '', child: ['', '', '']}]
          },
          {
            name: '2. 카 측 과속조절기',
            child: [{ name: '', child: ['', '', '']}]
          },
          {
            name: '3. 균형추(평형추) 추락방지 안전장치',
            child: [{ name: ''}]
          },
          {
            name: '4. 균형추/평형추 과속조절기',
            child: [{ name: '', child: ['', '', '']}]
          },
          {
            name: '5. 멈춤 쇠 장치',
            child: [{ name: '', child: ['', '']}]
          },
          {
            name: '6. 전기적크리핑 방지시스템',
            child: [{ name: ''}]
          },
          {
            name: '7. 카의상승과속방지장치',
            child: [{ name: '', child: ['', '']}]
          },
          {
            name: '8. 카의개문출발방지장치',
            child: [{ name: '', child: ['', '']}]
          }
        ]
      })
      list.push({
        name: '주행성능 측정',
        child: [
          {
            name: '1. 일반적인 주행시험',
            child: [{ name: '-', child: ['', '']}]
          },
          {
            name: '2. 유압시스템의 점검',
            child: [{ name: '-', child: ['', '', '', '', '', '', '', '']}]
          }
        ]
      })
      list.push({
        name: '보호장치',
        child: [
          {
            name: '1. 전동기의 보호',
            child: [{ name: '-' }]
          },
          {
            name: '2. 전동기 구동시간 제한장치',
            child: [{ name: '-' }]
          },
          {
            name: '3. 조명 및 콘센트의 보호',
            child: [{ name: '-' }]
          }
        ]
      })
      list.push({
        name: '전기적 보호',
        child: [
          {
            name: '1. 접지에 의한 절연저항',
            child: [{ name: '-' }]
          },
          {
            name: '2. 전기배선',
            child: [{ name: '-', child: ['', '', ''] }]
          }
        ]
      })
      list.push({
        name: '장애인용 엘리베이터 추가요건',
        child: [
          {
            name: '1. 승강장의 공간',
            child: [{ name: '-' }]
          },
          {
            name: '2. 조작설비',
            child: [{ name: '-', child: ['', ''] }]
          },
          {
            name: '3. 기타설비',
            child: [{ name: '-', child: ['', '', '', ''] }]
          }
        ]
      })
      list.push({
        name: '소방구조용 엘리베이터 추가요건',
        child: [
          {
            name: '1. 건축물의 요건',
            child: [{ name: '-' }]
          },
          {
            name: '2. 전기장치의 물에 대한 보호',
            child: [{ name: '-' }]
          },
          {
            name: '3. 소방관의 구출',
            child: [{ name: '-', child: ['', ''] }]
          },
          {
            name: '4. 제어 시스템',
            child: [{ name: '-', child: ['', '', '', '']}]
          }
        ]
      })
      list.push({
        name: '피난용 엘리베이터 추가요건',
        child: [
          {
            name: '1. 건축물의 요건',
            child: [{ name: '-' }]
          },
          {
            name: '2. 전기장치의 물에 대한 보호',
            child: [{ name: '-' }]
          },
          {
            name: '3. 탑승자의 구출',
            child: [{ name: '-', child: ['', ''] }]
          },
          {
            name: '4. 제어 시스템',
            child: [{ name: '-', child: ['', '', ''] }]
          }
        ]
      })

      for (let i = 0; i < this.form.body.elevatorInfo.workTypeTitleList.length; i++) {
        if (this.form.body.elevatorInfo.workType[i]) {
          menus.push(list[i])
        }
      }

      return menus
    },
    menuResults () {
      return ['A', 'B', 'C', '제외', '없음', 'A', 'B', 'C', '제외', '없음']
    },
    comName () {
      if (this.isUpdateMode) {
      } else {
        return this.$store.state.company.companyInfo.com_name;
      }
    },
    projName () {
      return this.$store.state.project.projectInfo.field_name;
    }
  },
  watch: {
    'comName' (value) {
      this.form.body.baseInfo.com_name = value;
    },
    'projName' (value) {
      this.form.body.baseInfo.project_name = value;
    }
  },
  mounted () {
    this.board.slug = this.boardSlug

    if (this.comName) {
      this.form.body.baseInfo.com_name = this.comName
    }
    if (this.projName) {
      this.form.body.baseInfo.project_name = this.projName
    }

    if (this.isUpdateMode) {
      this.loadPost()
    }
  },
  methods: {

    async loadPost () {
      const boardSlug = this.$route.params.boardSlug
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/LOAD_POST', {
        boardSlug,
        postId
      })

      if (!this.$store.state.approval.postInfo) {
        alert('열람 권한이 없습니다.')
        this.oldForm = this.form
        this.$router.back()
        return
      }

      // 내용
      const post = JSON.parse(this.$store.state.approval.postInfo.post_content)
      this.form = post

      const files = this.$store.state.approval.postInfo.post_attachment
      if (files) {
        for (const file of files) {
          this.fileList.push({
            id: file.id,
            fileName: file.file_name,
            fileSize: file.file_size,
            path: file.path,
            thumb: file.thumb
          })
        }
      }

      // TODO : 결재프로세스
      await this.$store.dispatch('USER_INFO')
      const myId = this.$store.state.auth.userInfo.id
      const doc = this.$store.state.approval.document
      this.board.slug = this.boardSlug
      this.board.statusCode = doc.status.code
      this.board.writer = doc.writer
      this.board.turnApprovalId = doc.turn_approval_id
      this.board.isWriter = (this.board.writer.id === myId)
      this.board.isTurnApproval = (this.board.turnApprovalId === myId && (this.board.statusCode === 'registered' || this.board.statusCode === 'ongoing'))
      this.board.readonly = !(this.board.statusCode === 'temp' || this.board.statusCode === 'rejected')
      this.board.resend = (this.board.isWriter && this.board.statusCode === 'rejected')
      this.board.isCompleteApproval = (this.board.statusCode === 'approved' || this.board.statusCode === 'rejected')
      this.board.savable = this.board.isWriter && (this.board.statusCode === 'temp')
      this.board.collection = this.board.isWriter && (this.board.statusCode === 'registered')
      this.board.approvalLine = doc.line.slice() // 모듈 표기용
    },

    convertFileListToApiFiles () {
      let uploads = '[]'
      const uploadFileIds = []

      if (this.fileList && this.fileList.length > 0) {
        for (const file of this.fileList) {
          uploadFileIds.push(file.id)
        }
        uploads = JSON.stringify(uploadFileIds)
      }

      return uploads
    },

    getOptions (option) {
      const projectId = parseInt(this.$route.params.proj_id)

      const content = JSON.stringify(this.form)
      const uploads = this.convertFileListToApiFiles()

      return {
        projectId,
        content,
        uploads,
        ...option
      }
    },

    async sendUpload (option) {
      if (this.isUpdateMode) {
        const postId = parseInt(this.$route.params.postId)
        await this.$store.dispatch('approval/UPDATE_POST', {postId, unTemp:'y', ...this.getOptions(option)})
      } else {
        await this.$store.dispatch('approval/CREATE_POST', {...this.getOptions(option)})
      }
      alert('상신되었습니다.')
      this.onClickClose()
    },
    async sendTemp (option, isCreate) {
      // 임시 저장하기
      if (isCreate || !this.isUpdateMode) {
        await this.$store.dispatch('approval/CREATE_POST', {isTemp: 1, ...this.getOptions(option)})
      } else {
        const postId = parseInt(this.$route.params.postId)
        await this.$store.dispatch('approval/UPDATE_POST', {postId, unTemp: 'n', ...this.getOptions(option)})
      }
      alert('임시저장되었습니다.')
      this.onClickClose()
    },

    onChangeInput (value, files) {
      this.form.body = value
      this.fileList = files
    },

    onClickClose () {
      // 닫기
      this.$router.back()
    },
    async onClickDelete () {
      // 삭제
      if (confirm('삭제하시겠습니까?')) {
        const boardSlug = this.boardSlug
        const postId = this.$route.params.postId
        await this.$store.dispatch('approval/DELETE_POST', {boardSlug, postId})
        this.oldForm = this.form
        this.onClickClose()
      }
    },
    onClickPrint () {
      // 프린트
      this.isPrint = true
      this.$store.commit('ui/SET_IS_PRINT', true)

      setTimeout(() => {
        const g_oBeforeBody = document.getElementById('print').innerHTML
        const g_oBeforeApproval = document.getElementById('print-approval').innerHTML
        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = '#fff'
          document.body.innerHTML = `${g_oBeforeBody}<br>${g_oBeforeApproval}`
        }
        window.print()
        location.reload()
      }, 300)
    },
    async onClickRecall (option) {
      // 결재문서 회수
      if (confirm('회수 후 임시저장 상태로 변경하시겠습니까?')) {
        await this.sendTemp(option)
      }
    },
    async onClickTempsave (option) {
      // 임시 저장하기
      await this.sendTemp(option)
    },
    async onClickReTempsave (option) {
      // 재상신
      await this.sendTemp(option, true)
    },
    async onClickUpload (option) {
      // 상신
      await this.sendUpload(option)
    },
    async onClickOk () {
      // 승인
      const postId = this.$route.params.postId
      await this.$store.dispatch('approval/APPROVE_OK', {postId})
      this.onClickClose()
    },
    async onClickNo (text) {
      // 반려
      const postId = parseInt(this.$route.params.postId)
      const comment = text
      await this.$store.dispatch('approval/APPROVE_NO', { postId, comment })
      this.onClickClose()
    }
  }
}
</script>

<style scoped>

</style>
